import { SyncedRemoteCollectionStore } from "@softline/core";
import {Item} from '../types/item';
import {Favorite} from '../types/favorite';

export const FavoriteItemsStore = SyncedRemoteCollectionStore.create<Favorite>()
